export * from "./http.service";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/http/index.ts